<template>
  <KeepAlive>
    <component
      v-bind="props"
      :is="activeConnectTypeComponent"
      :active-connect-type="activeConnectType"
      :need-prompt-enable-o-work="needPromptEnableOWork"
      :device-name="currentDeviceName"
      @show-toast="showToast"
      @toggle-connect-type="toggleConnectType"
      @cancel="close"
    />
  </KeepAlive>
</template>

<script lang="ts">
  const ON_CANCEL = 'cancel'
</script>

<script lang="ts" setup>
  import { INSTANCE as DeviceManager } from '@core/devices/DeviceManager'
  import { computed, onBeforeUnmount, onMounted, ref } from 'vue'
  import { INSTANCE as ToastManager } from '@/core/ToastManager'
  import { ConnectionState } from '@/core/devices/IDevice'
  import { INSTANCE as DevicePullUpTaskManager } from '@/core/DevicePull/DevicePullUpTaskManager'
  import PullUpDeviceByManualConfirm from '@/components/pullUpDeviceGuide/PullUpDeviceByManualConfirm.vue'
  import PullUpDeviceByPasswordConfirm from '@/components/pullUpDeviceGuide/PullUpDeviceByPasswordConfirm.vue'
  import { PullUpDeviceType, PullUpDeviceState } from '@/core/DevicePull/DevicePullUpTask'
  import PullUpDeviceGuidePlaceHolder from '@components/pullUpDeviceGuide/PullUpDeviceGuidePlaceHolder.vue'

  const props = defineProps<{
    deviceId: string
    pullUpDeviceState?: PullUpDeviceState
  }>()

  const emit = defineEmits([ON_CANCEL])

  const activeConnectType = ref(PullUpDeviceType.BY_MANUAL_CONFIRM)
  const needPromptEnableOWork = computed(
    () =>
      props.pullUpDeviceState === PullUpDeviceState.ERR_OWORK_DISABLED ||
      props.pullUpDeviceState === PullUpDeviceState.ERR_UNSET_PASSWORD
  )
  // TODO:看能否用vue的渲染函数抽离和复用<PullUpDeviceByManualConfirm><PullUpDeviceByPasswordConfirm>两组件的公共代码
  const activeConnectTypeComponent = computed(() => {
    if (needPromptEnableOWork.value) return PullUpDeviceGuidePlaceHolder

    return activeConnectType.value === PullUpDeviceType.BY_MANUAL_CONFIRM
      ? PullUpDeviceByManualConfirm
      : PullUpDeviceByPasswordConfirm
  })

  const currentDeviceName = ref<string | undefined>(DeviceManager.getDeviceById(props.deviceId)?.model)

  const hideToast = () => {
    ToastManager.hide()
  }

  const showToast = (tips: string | undefined) => {
    if (tips) {
      ToastManager.show(tips)
    } else {
      console.log('tips get error')
    }
  }

  const toggleConnectType = () => {
    activeConnectType.value =
      activeConnectType.value === PullUpDeviceType.BY_MANUAL_CONFIRM
        ? PullUpDeviceType.BY_PASSWORD
        : PullUpDeviceType.BY_MANUAL_CONFIRM
  }

  const deviceListener = {
    onDeviceListUpdated: () => {
      const device = DeviceManager.getDeviceById(props.deviceId)

      if (device?.connectionState === ConnectionState.CONNECTED) {
        close()
      }
    },
    onCurrentSelectedDeviceChanged: () => {
      // do nothing
    },
    onInitialized(): void {
      // do nothing
    },
  }

  const close = () => {
    hideToast()
    emit(ON_CANCEL)
  }

  onMounted(() => {
    DeviceManager.addChangeListener(deviceListener)
  })

  onBeforeUnmount(() => {
    hideToast()
    DevicePullUpTaskManager.resetTask(props.deviceId)
    DeviceManager.removeChangeListener(deviceListener)
  })
</script>

<style lang="stylus" scoped></style>
